import { jsx as _jsx } from "react/jsx-runtime";
import { SelectAll, radioSelector } from '../../../../components/factories/DataGrid';
const debug = process.env.REACT_APP_DEBUG && false;
export const addSelectColumn = ({ togglePresenceInSelectedObjects, selectedObjects, setSelectedObjects, isInSelectedObjects, rows, columns, }) => {
    const togglePresenceInSelectedObjectsShim = (v, id) => {
        togglePresenceInSelectedObjects(id);
    };
    const select = {
        field: 'select',
        valueGetter: (value, row, column, apiRef) => isInSelectedObjects({ id: row.id }),
        renderCell: (gridCellParams) => radioSelector({ gridCellParams, valueSetter: togglePresenceInSelectedObjectsShim }),
        renderHeader: (gridHeaderParams) => _jsx(SelectAll, { items: rows, selectedObjects, setSelectedObjects }),
    };
    const columnsOut = [select, ...columns];
    const rowsOut = rows.map((row) => {
        return {
            select: isInSelectedObjects(row),
            ...row,
        };
    });
    return {
        rows: rowsOut,
        columns: columnsOut,
    };
};
